import { useMemo } from 'react';
import { CategoryGroup } from '../types/category';

/**
 * A hook that returns the categoryId of Category object used to determine subcategories to display
 * Takes grouped data from useCategoryGroups hook
 * @param categoryName: String
 * @param extraDimension: String[]
 * @param categoryIds: Category[]
 *
 * Used to match and filter subcategories to display in dropdown
 * Returns specific categoryId to be used to determine subcategories
 *
 * @returns categoryId {String} - id of categoryObject if exists, else ''
 */

const useCategoryId = (
  selectedCategoryName: string,
  selectedExtraDimension: string,
  categoryGroups: { [key: string]: CategoryGroup },
) =>
  useMemo(() => {
    if (!selectedCategoryName) return '';

    const selectedCategoryGroup = categoryGroups[selectedCategoryName];
    if (!selectedCategoryGroup) return '';

    if (selectedExtraDimension && selectedCategoryGroup.categoryIds[selectedExtraDimension]) {
      return selectedCategoryGroup.categoryIds[selectedExtraDimension];
    }

    if (selectedCategoryGroup.categoryIds['']) {
      return selectedCategoryGroup.categoryIds[''];
    }

    return '';
  }, [selectedCategoryName, selectedExtraDimension, categoryGroups]);

export default useCategoryId;
